export const selectStateCase = (store) => store.case.state;
export const selectCommentLoading = (store) => store.case.loadingComment;
export const selectCase = (store) => store.case.case;
export const selectCaseErrors = (store) => store.case.errors;
export const selectAutomaticsLogs = (store) => store.case.automaticsLogs;
export const selectDocumentLoading = (store) => store.case.documentLoading;
